/**
 * Labels + Badge-Klassen fuer den Urlaub/Krank-Bereich (Muster
 * components/attendance/labels.ts).
 */

import type { SickLeaveType } from "@/types"

export const SICK_TYPE_LABEL: Record<SickLeaveType, string> = {
  SHORT: "Kurz (ohne AU)",
  WITH_CERTIFICATE: "Mit AU",
  LONG_TERM: "Langzeit",
  CHILD_SICK: "Kind krank",
}

export const SICK_TYPE_BADGE: Record<SickLeaveType, string> = {
  SHORT: "border-sky-300 bg-sky-100 text-sky-800",
  WITH_CERTIFICATE: "border-amber-300 bg-amber-100 text-amber-800",
  LONG_TERM: "border-purple-300 bg-purple-100 text-purple-800",
  CHILD_SICK: "border-emerald-300 bg-emerald-100 text-emerald-800",
}

export const SICK_TYPE_VALUES = Object.keys(SICK_TYPE_LABEL) as SickLeaveType[]
